import * as actionTypes from '../actions/actionTypes.js';
import { updateObject } from '../utility.js';

const initialState = {
    loading: false,
    successful: false,
    failed: false
};

const translationLoadStart = ( state, action ) => {
    return updateObject( state, { ...initialState, loading: true } );
};

const translationLoadSuccess = ( state, action ) => {
    return updateObject( state, {
        loading: false,
        successful: true
    } );
};

const translationLoadFail = ( state, action ) => {
    return updateObject( state, { loading: false, failed: true } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.TRANSLATION_LOAD_START: return translationLoadStart( state, action );
    	case actionTypes.TRANSLATION_LOAD_SUCCESS: return translationLoadSuccess( state, action );
    	case actionTypes.TRANSLATION_LOAD_FAIL: return translationLoadFail( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/translationLoad.js